import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  FormFeedback,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addQuestionnaire, editQuestionnaire } from "store/actions";
import { withTranslation } from "react-i18next";
import Flatpickr from "react-flatpickr";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const AddEditModal = (props) => {
  const { modal, toggle, isEdit, itemData, fetchQuestionnaireListData } = props;
  const [questionnaireData, setQuestionnaireData] = useState();
  const { error, success, loading, editLoading } = useSelector((state) => ({
    loading: state.Questionnaire.loading,
    error: state.Questionnaire.error,
    success: state.Questionnaire.success,
    editLoading: state?.Questionnaire?.editLoading,
  }));
  const [deadLine, setDeadline] = useState(null);
  const utcDate = new Date(itemData?.creation_date); // UTC Date
  const localDate = itemData?.creation_date
    ? new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000)
    : new Date();
  const dispatch = useDispatch();

  useEffect(() => {
    setQuestionnaireData(itemData);
    // setDeadline(itemData?.creation_date)
  }, [itemData]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      questionnaire_name: questionnaireData?.questionnaire_name || "",
      client_name: questionnaireData?.client_name || "",
      creation_date: questionnaireData?.creation_date || "",
      is_active: questionnaireData?.is_active || "Y",
    },
    validationSchema: Yup.object({
      questionnaire_name: Yup.string().required(
        props.t("Please Enter Questionnaire Name")
      ),
      client_name: Yup.string().required(props.t("Please Enter Client Name")),
      // creation_date: Yup.string().required(props.t("Please Enter Creation Date")),
      is_active: Yup.string().required(
        props.t("Please Enter Questionnaire Status")
      ),
    }),
    onSubmit: (values, { resetForm }) => {
      const date = new Date();
      // if(!deadLine){
      //     toastr.error("Please Enter Deadline.");
      //     return
      // }
      values = {
        ...values,
        creation_date:
          deadLine != null
            ? new Date(
                Date.UTC(
                  deadLine.getFullYear(),
                  deadLine.getMonth(),
                  deadLine.getDate(),
                  deadLine.getHours(),
                  deadLine.getMinutes()
                )
              )
            : isEdit
            ? new Date(
                Date.UTC(
                  localDate.getFullYear(),
                  localDate.getMonth(),
                  localDate.getDate(),
                  localDate.getHours(),
                  localDate.getMinutes()
                )
              )
            : date,
      };

      if (isEdit) {
        dispatch(
          editQuestionnaire(values, questionnaireData?.id, (res) => {
            if (res.status === "success") {
              toastr.success(res.message);

              resetForm({
                questionnaire_name: "",
                client_name: "",
                creation_date: "",
                is_active: "",
              });
              fetchQuestionnaireListData();
              toggle();
              setDeadline();
            } else {
              toastr.error(res.message);
              toggle();
            }
          })
        );
      } else {
        dispatch(
          addQuestionnaire(values, props?.router?.navigate, (res) => {
            if (res?.status === "success") {
              toastr.success(res.message);

              resetForm({
                questionnaire_name: "",
                client_name: "",
                creation_date: "",
                is_active: "",
              });
              fetchQuestionnaireListData();
              toggle();
              setDeadline();
            } else {
              toastr.error(res.message);
              toggle();
            }
          })
        );
      }
    },
  });

  return (
    <React.Fragment>
      <Modal
        isOpen={modal}
        toggle={() => {
          toggle();
        }}
      >
        <ModalHeader
          tag="h4"
          toggle={() => {
            toggle();
          }}
        >
          {!!isEdit
            ? props.t("Edit Questionnaire")
            : props.t("Add Questionnaire")}
        </ModalHeader>
        <ModalBody>
          <Form
            className="form-horizontal"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <div className="mb-3 d-block">
              <Label className="form-label m-0 pb-1">
                {props.t("Questionnaire Name")}:
              </Label>
              <Input
                name="questionnaire_name"
                className="form-control"
                placeholder={props.t("Enter Questionnaire Name")}
                type="text"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.questionnaire_name || ""}
                invalid={
                  validation.touched.questionnaire_name &&
                  validation.errors.questionnaire_name
                    ? true
                    : false
                }
              />
              {validation.touched.questionnaire_name &&
              validation.errors.questionnaire_name ? (
                <FormFeedback type="invalid">
                  {validation.errors.questionnaire_name}
                </FormFeedback>
              ) : null}
            </div>
            <div className="mb-3 d-block">
              <Label className="form-label m-0 pb-1">
                {props.t("Creation Date")}:
              </Label>
              <DatePicker
                name="creation_date"
                className="form-control d-block"
                selected={deadLine ? deadLine : localDate}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                scrollableYearDropdown
                yearDropdownItemNumber={201} // Set the number of years to show (this doesn't actually limit it)
                // Make the year dropdown scrollable
                // Custom year dropdown to display years from 1900 to 2100
                yearDropdownItems={Array.from(
                  { length: 201 },
                  (v, k) => k + 1900
                )}
                placeholderText="YYYY-MM-DD"
                onChange={(date) => {
                  setDeadline(date);
                }}
                dateFormat="yyyy-MM-dd"
              />
              {/* <Flatpickr
                                name="creation_date"
                                className="form-control d-block"
                                placeholder="yyyy-mm-dd"
                                options={{
                                  altInput: true,
                                  altFormat: "Y-m-d", 
                                  dateFormat: "Y-m-d" 
                                }}
                                value={deadLine}
                                onChange={(e) => setDeadline(e[0])}
                            /> */}
              {/* <Input
                                style = {{cursor: "pointer"}}
                                name="creation_date"
                                className="form-control"
                                placeholder={props.t("Enter Creation Date")}
                                type="date"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={(validation.values.creation_date || "").split("T")[0]}
                                invalid={
                                    validation.touched.creation_date && validation.errors.creation_date ? true : false
                                }
                            />
                            {validation.touched.creation_date && validation.errors.creation_date ? (
                                <FormFeedback type="invalid">{validation.errors.creation_date}</FormFeedback>
                            ) : null} */}
            </div>
            <div className="mb-3 d-block">
              <Label className="form-label m-0 pb-1">
                {props.t("Client Name")}:
              </Label>
              <Input
                name="client_name"
                className="form-control"
                placeholder={props.t("Enter Client Name")}
                type="text"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.client_name || ""}
                invalid={
                  validation.touched.client_name &&
                  validation.errors.client_name
                    ? true
                    : false
                }
              />
              {validation.touched.client_name &&
              validation.errors.client_name ? (
                <FormFeedback type="invalid">
                  {validation.errors.client_name}
                </FormFeedback>
              ) : null}
            </div>

            <div className="mb-3 d-flex align-items-center gap-3">
              <Label className="form-label m-0">{props.t("Status")}:</Label>
              <div className="d-flex align-items-center gap-2">
                <Input
                  id="yes"
                  name="is_active"
                  type="radio"
                  checked={validation.values.is_active == "Y" ? true : false}
                  value="Y"
                  onClick={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.is_active && validation.errors.is_active
                      ? true
                      : false
                  }
                />
                <Label for="yes" className="form-label m-0">
                  {props.t("Active")}
                </Label>
                <Input
                  id="no"
                  name="is_active"
                  checked={validation.values.is_active === "N" ? true : false}
                  value="N"
                  type="radio"
                  onClick={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.is_active && validation.errors.is_active
                      ? true
                      : false
                  }
                />
                <Label for="no" className="form-label m-0">
                  {props.t("In-Active")}
                </Label>
              </div>
              {validation.touched.is_active && validation.errors.is_active ? (
                <FormFeedback type="invalid">
                  {validation.errors.is_active}
                </FormFeedback>
              ) : null}
            </div>

            {editLoading ? (
              <div className="btn-login-admin mt-3 batches-add-modal-btn">
                <button
                  type="button"
                  className="btn btn-primary btn-block d-flex"
                  disabled
                >
                  <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                  {props.t("Submit")}
                </button>
              </div>
            ) : (
              <div className="btn-login-admin mt-3 batches-add-modal-btn">
                <button
                  className="btn btn-primary btn-block"
                  type="submit"
                  // disabled
                >
                  {props.t("Submit")}
                </button>
              </div>
            )}
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

AddEditModal.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
};
export default withTranslation()(AddEditModal);
